import { IWeatherType } from "../entities/DTO-models/IWeatherType";
import { mtbService } from "./mtbService";
import {
  ErrorCode,
  InSufficientTenantRights,
  InvalidTenantError,
  NotFoundError,
  WeatherUnavailableError,
} from "../entities/Error/ErrorCodes";

export class WeatherService {
  public async getWeatherForArea(
    tenantKey: string,
    areaId: number
  ): Promise<IWeatherType> {
    try {
      const url = `/tenant/${tenantKey}/area/${areaId}/weather`;
      const json = await mtbService.getProtected(url);
      return json.data as IWeatherType;
    } catch (errResponse: any) {
      const errCode: ErrorCode = errResponse.response?.data
        .errorCode as ErrorCode;
      switch (errCode) {
        case ErrorCode.InsufficientRights:
          throw new InSufficientTenantRights();
        case ErrorCode.InvalidTenantError:
          throw new InvalidTenantError();
        case ErrorCode.NotFound:
          throw new NotFoundError();
        case ErrorCode.WeatherUnavailable:
          throw new WeatherUnavailableError();
        default:
          break;
      }
      throw errResponse;
    }
  }
}
